// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2D8-B","actions":"styles_actions__3SJ2p","error":"styles_error__3BQHy","message":"styles_message__3iSQ0"};